import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, CardBody, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import IssuePagination from './IssuePagination';
import IssuesTable from './IssuesTable';
import NoDataDashboard from '../../components/NoDataDashboard';
import Loader from '../../components/Loader';
import AxiosContext from '../../helpers/AxiosContext';
import IssueInformation from '../../components/IssueInformation/IssueInformation';
import notify from '../../helpers/toast-notify';

const IssuesList = (props) => {
    const listUrl = props.listUrl;
    const pageSize = props.pageSize || 10;
    const axios_api = useContext(AxiosContext).axios;
    const [entries, setEntries] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [nextPage, setNextPage] = useState(null);
    const [prevPage, setPrevPage] = useState(null);
    const [lastPage, setLastPage] = useState(1);
    const [isOpen, setOpen] = useState(false);
    const [entry, setEntry] = useState(null);
    const [loading, setLoading] = useState(true);

    const changePage = (value) => {
        if (value === currentPage) {
            return;
        }
        if (value > 0 && value <= lastPage) {
            if (value === lastPage) {
                setPrevPage(value - 1);
                setNextPage(null);
            } else if (value === 1) {
                setPrevPage(null);
                setNextPage(value + 1);
            } else {
                setPrevPage(value - 1);
                setNextPage(value + 1);
            }
            setCurrentPage(value);
        }
    };

    const getVulnerabilities = async () => {
        if (listUrl) {
            let res = await axios_api.get(listUrl, { params: { page: currentPage } }).catch((e) => {
                console.error(e);
            });

            if (res) {
                let data = res.data;

                if (data.next) {
                    setNextPage(currentPage + 1);
                } else {
                    setNextPage(null);
                }
                if (data.previous) {
                    setPrevPage(currentPage - 1);
                } else {
                    setPrevPage(null);
                }

                setLastPage(Math.ceil(data.count / pageSize));

                let fullData = [];
                for (let issue of data.results) {
                    let fullIssue = {};
                    if (issue.general_issue) {
                        const generalIssueData = issue['general_issue'];
                        // Remove combined key/value from displayed array
                        delete issue['general_issue'];
                        fullIssue['name'] = generalIssueData.name;
                        fullIssue['description'] = generalIssueData.description;
                        fullIssue['recommendation'] = generalIssueData.recommendation;
                        fullIssue['severity'] = generalIssueData.severity;
                        fullIssue['generalIssueId'] = generalIssueData.id;
                    }
                    // Combine general issue data with original data and append
                    // Rather than simply add fields, which would be displayed at end
                    fullData.push(Object.assign(fullIssue, issue));
                }
                setEntries(fullData);
            }
        }
        setLoading(false);
    };

    const getHeaders = () => {
        if (entries.length > 0) {
            return Object.keys(entries[0]);
        }
        return [];
    };

    useEffect(() => {
        getVulnerabilities();
    }, [currentPage]);

    useEffect(() => {
        if (entry) {
            setOpen(true);
        }
    }, [entry]);

    if (loading) {
        return <Loader />;
    }

    if (entries.length === 0) {
        return <NoDataDashboard />;
    }

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <IssuesTable issues={entries} setEntry={setEntry} headers={getHeaders()} type={props.type} />
                    <IssuePagination
                        currentPage={currentPage}
                        nextPage={nextPage}
                        prevPage={prevPage}
                        changePage={changePage}
                        lastPage={lastPage}
                    />
                </CardBody>
            </Card>
            <Modal
                size="xl"
                isOpen={isOpen}
                toggle={() => {
                    setOpen(!isOpen);
                }}>
                <ModalHeader
                    className="custom-modal-header"
                    toggle={() => {
                        setOpen(!isOpen);
                    }}>
                    <div className="modal-icon-wrapper">
                        <i className="icon-list_ol" />
                    </div>
                    <span>Details</span>
                </ModalHeader>
                <ModalBody>
                    <IssueInformation selected={entry} />
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default IssuesList;
